import { Route, Routes } from "react-router-dom";
import { useSetPageTitle } from "../../context/PageTitleContext";
import Wiki from "./wiki";

const WikiRoutes = () => {
  useSetPageTitle("Dispense wiki", "Consulta e gestisci le dispense didattiche");

  return (
    <div className="mx-auto max-w-5xl px-4 py-6 sm:px-6 lg:px-8">
      <Routes>
        <Route index element={<Wiki />} />
      </Routes>
    </div>
  );
};

export default WikiRoutes;
